import Vue from 'vue';
import Axios from "axios";
import Loading from 'vue-loading-overlay';
import MessageService from '@/util/messageService.js';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading, {
  color: '#ff6f3c',
  height: 72,
  width: 72,
  backgroundColor: '#000000',
  opacity: 0.1
});

var loadingCounter = 0;
var loading;

/*
AjaxService
  用來Ajax呼叫後端
*/
const AjaxService = {

  async post(url, param, successCallBack, failCallBack, isDeactivateLoading) {
    
    // 從 const.json 取得需要replace的domain
    // 修改domain時需要在前後加上 "/", 例如 /OAS_P2/
    await Axios.get("static/config/const.json").then(({
      data
    }) => {
      url = url.replace('/oasPromo/', data.backendDomain)
    });

    // 開啟畫面轉圈圈
    this.loadingShow(isDeactivateLoading);

    Axios.post(url, param, {
      headers: {
        Authorization: 'Bearer ' + window.sessionStorage.UID
      }
    }).then(((res) => {
      if (res && res.data) {
        let appCode = res.data.appCode;
        if (appCode.indexOf("SUCCESS") == 0) {
          if (successCallBack) {
            successCallBack(res.data);
          } else {
            MessageService.showSuccess('成功');
          }
        } else {
          if (failCallBack) {
            failCallBack(res.data);
          } else {
            MessageService.showError(res.data.appMsg);
          }
        }
      }

      // 正常關閉畫面轉圈圈
      this.loadingHide(isDeactivateLoading);
    })).catch((res) => {
      if (failCallBack && res && res.data) {
        failCallBack(res.data);
      } else {
        MessageService.showError('錯誤', '請稍後重試')
      }

      // 正常關閉畫面轉圈圈
      this.loadingHide(isDeactivateLoading);
    });
  },

  // 打AJAX畫面顯示轉圈圈統一由ajaxService處理
  // 除了載入證件照的方法之外
  loadingShow(isDeactivateLoading) {

    // 若url包含此字:downloadIdentifyPhoto,代表是取得證件照的request
    // 該request的轉圈圈由該方法自己實作,故這邊不用處理
    if (!isDeactivateLoading) {
      if (loadingCounter == 0) {
        loading = Vue.$loading.show();
      }
      loadingCounter += 1;
    }
  },

  // 打AJAX畫面關閉轉圈圈統一由ajaxService處理
  // 除了載入證件照的方法之外
  loadingHide(isDeactivateLoading) {

    // 若url包含此字:downloadIdentifyPhoto,代表是取得證件照的request
    // 該request的轉圈圈由該方法自己實作,故這邊不用處理
    if (!isDeactivateLoading) {
      if (loadingCounter <= 1) {
        loading.hide();
      }
      loadingCounter -= 1;
    }
  }
}

export default AjaxService;


// WEBPACK FOOTER //
// ./src/util/ajaxService.js